const MISCELLANEOUS = {
    pageDataAid: "accountRelatedForm",
    pageTitle: {
        text: 'Account related forms',
        dataAid: 'accountForm'
    },
}

const CONTENT = {
    kycFormRow: {
        rowDataAid: 'kycForm',
        title: {
            text:'Account opening form',
            dataAid: 'title' // kycForm
        },
    },
    cmlForm : {
        rowDataAid: 'cmlForm',
        title: {
            text:'Client master report',
            dataAid: 'title'
        },
        fetchErrorToast: {
            text: "Could not fetch CML status. Please try again"
        },
    },
    emailSuccessToast: {
        text: 'Document is successfully sent to your registered email'
    },
    emailErrorToast: {
        text: "Could not initiate email. Please try again later"
    }
}

const ACCOUNT_RELATED_FORM  = {
    ...MISCELLANEOUS,
    CONTENT
}
export default ACCOUNT_RELATED_FORM
